import Chocobean from "../images/chocobean.svg";
import Chococup from "../images/chococup.svg";
import Chocoheart from "../images/chocoheart.svg";
import Chocotablet from "../images/chocotablet.svg";

function DetailsSweets() {
  return (
    <div className="container mt-5 mb-5">
      <hr className="fw-bold mb-5" />
      <div className="row mt-5">
        <div className="col-6 col-md-3 mb-2">
          <div>
            <small>
              <img className="icon" src={Chocobean} alt="choco-bean"></img>
            </small>
            <p className="fw-bold mt-4">With care</p>
            <span>Carefully crafted from bean to bar</span>
          </div>
        </div>
        <div className="col-6 col-md-3">
          {" "}
          <div>
            <small>
              <img className="icon" src={Chococup} alt="cup"></img>
            </small>
            <p className="fw-bold mt-4">Dosage</p>
            <span>1 teabag</span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-2">
          {" "}
          <div>
            <small>
              <img className="icon" src={Chocoheart} alt="heart"></img>
            </small>
            <p className="fw-bold mt-4">With love</p>
            <span>Use of high-quality ingredients</span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-2">
          {" "}
          <div>
            <small>
              <img className="icon" src={Chocotablet} alt="tablet"></img>
            </small>
            <p className="fw-bold mt-4">Ingredients</p>
            <span>Use of high-quality ingredients</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailsSweets;
